module.exports = __webpack_public_path__ + "img/5167dde.png";